import { styled } from '@linaria/react'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const UpgradeCurrentPackageSC = styled.div<{ smallPlayer?: boolean }>`
  z-index: 0;
  position: absolute;
  transform: translate(-50%, -50%);
  left: ${({ smallPlayer }) => (smallPlayer ? '50%' : '50dvw')};
  top: ${({ smallPlayer }) => (smallPlayer ? '50%' : '50dvh')};
  display: flex;
  flex-direction: column;
  gap: var(${FIXED_INDENTS.INDENT_30});
  width: 22rem;

  ${MEDIA.MIN_600} {
    width: 26rem;
  }

  ${MEDIA.MIN_1240} {
    width: auto;
  }
`
